import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  titleContainer: {
    backgroundColor: "#E2E7EF",
  },
  subtitle: {
    fontSize: "1.4rem",
  },
  contentTitles: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
  },
  textfield: {
    marginRight: theme.spacing(2),
    marginBottom: "24px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  formContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  formHelperText: {
    marginLeft: "0px",
    position: "absolute",
    bottom: "-35px",
  },
}))

export default styles
